(() => {
  const SELECTOR = '[data-mbb-why-choose-us]';

  class MbbWhyChooseUs {
    constructor(section) {
      if (!section || section.dataset.mbbWhyInitialized === 'true') return;

      this.section = section;
      this.items = [...section.querySelectorAll('[data-mbb-why-reveal]')];
      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.init();
    }

    init() {
      this.section.dataset.mbbWhyInitialized = 'true';

      if (
        this.reducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        this.reveal();
        return;
      }

      this.observer = new IntersectionObserver(
        entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;

          this.reveal();
          this.observer.disconnect();
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      this.observer.observe(this.section);
    }

    reveal() {
      this.section.classList.add('is-visible');

      this.items.forEach(item => {
        item.classList.add('is-visible');
      });
    }

    destroy() {
      this.observer?.disconnect();

      this.section.classList.remove('is-visible');

      this.items.forEach(item => {
        item.classList.remove('is-visible');
      });

      delete this.section.dataset.mbbWhyInitialized;
    }
  }

  const getSections = root => {
    if (root.matches?.(SELECTOR)) return [root];

    return [...(root.querySelectorAll?.(SELECTOR) || [])];
  };

  const init = root => {
    getSections(root).forEach(section => {
      if (section.dataset.mbbWhyInitialized === 'true') return;

      section.mbbWhyChooseUs = new MbbWhyChooseUs(section);
    });
  };

  const start = () => init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    getSections(event.target).forEach(section => {
      section.mbbWhyChooseUs?.destroy();
      delete section.mbbWhyChooseUs;
    });
  });
})();